import { ContentType } from '@candu-ai/content/types';

export enum SelectorLocation {
  REPLACE = 'Replace',
  START = 'Start',
  END = 'End',
  MODAL = 'Modal',
}

export enum LogicOptions {
  ALL = 'All',
  ANY = 'Any',
}

export enum URLOptions {
  CONTAINS = 'Substring',
  STARTS = 'StartsWith',
  ENDS = 'EndsWith',
  EXACTLY = 'Equals',
  REGEX = 'Regex',
}

export enum ModalTimeFrames {
  UNTIL_DISMISSED = 'UntilDismissed',
  FOREVER = 'Forever',
}

export enum TriggerOptions {
  TRIGGER = 'trigger',
  PAGE_LOAD = 'pageLoad',
}

export interface PlacementUrl {
  operation: { operand: string; type: URLOptions };
  not?: boolean;
}

type ContentId = string;

export type PlacementId = string;

export interface ContentPlacement {
  id: PlacementId;
  contentId: ContentId;
  slug?: string;
  selector?: string;
  type?: ContentType;
  urls?: PlacementUrl[];
  denyURLs?: string[];
  location?: SelectorLocation;
  urlsLogicOperator?: LogicOptions;
  showTimeframe?: ModalTimeFrames;
  createdAt?: string;
  snapshotId?: string;
}

export interface TooltipPlacement {
  selector: string;
}
